'use client';

import { useParams } from 'next/navigation';
import React from 'react';

import { StrapiStop } from '@/apis/strapi';
import { doTranslation } from '@/app/i18n/client';
import styles from '@/components/bus-station/bus-station-map.module.scss';
import DelayedTrailwaysGoogleStopsMap from '@/components/global/maps/delayedTrailwaysGoogleStopsMap';

type Props = {
  details: boolean | false;
  markerIndex: number | null;
  state: string | null;
  stop: string | null;
  stops: StrapiStop[] | null;
  title: string;
};

const BusStationMap = (props: Props): React.JSX.Element => {
  const { lng }: any = useParams();
  const { t } = doTranslation(lng);

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h2 className={styles.title}>{props.title}</h2>
        <ol className={styles.stops}>
          {props.stops && props.stops.map((stop, index) => <li key={index}>{stop.attributes?.stop_name}</li>)}
        </ol>
      </div>
      <div className={styles.body}>
        <DelayedTrailwaysGoogleStopsMap
          details={props.details}
          markerIndex={props.markerIndex}
          stops={props.stops || []}
        />
      </div>
    </div>
  );
};

export default BusStationMap;
